"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebtorMenuItem = void 0;
const React = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const CreditBadge_1 = require("../CreditBadge/CreditBadge");
const MenuItem_1 = require("../MenuItem/MenuItem");
const history_svg_1 = __importDefault(require("../../assets/icons/history.svg"));
const DebtorContent = Theme_1.styled.div `
  .leftElement {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }
  .rightElement {
    display: flex;
    align-items: center;
    margin-left: 16px;
  }
  .debtorContent {
    align-items: center;
  }
  .debtorMainContent {
    display: flex;
    align-items: center;
  }
  .debtorSubContent {
    color: ${(props) => props.theme.gray3};
    font-size: 14px;
  }
  .debtorSuperContent {
    color: ${(props) => props.theme.red};
    font-size: 14px;
  }
`;
const LeftElement = Theme_1.styled.div `
  display: flex;
  align-items: center;
  margin-right: 16px;
`;
const RightElement = Theme_1.styled.div `
  display: flex;
  align-items: center;
  margin-left: 16px;
`;
const DebtorMenuItem = (props) => {
    return (React.createElement(MenuItem_1.MenuItem, null,
        renderCreditBadge(props.debtorInfo.rating),
        renderDebtorInfo(props.debtorInfo, props.displaySuper),
        renderHistoryIcon(props.debtorInfo.historyIcon)));
};
exports.DebtorMenuItem = DebtorMenuItem;
function renderCreditBadge(rate) {
    return (React.createElement(LeftElement, null,
        React.createElement(CreditBadge_1.CreditBadge, { badgeContent: rate })));
}
function renderDebtorInfo(debtorInfo, displaySuper = false) {
    return (React.createElement(DebtorContent, null,
        React.createElement("div", { className: "debtorMainContent" },
            React.createElement(LeftElement, null, debtorInfo.name),
            React.createElement("div", { className: "debtorSubContent" },
                "MC#",
                ' ',
                !debtorInfo.mc_number || debtorInfo.mc_number === ''
                    ? 'N/A'
                    : debtorInfo.mc_number)),
        React.createElement("div", { className: "debtorSubContent" },
            debtorInfo.address1 ? `${debtorInfo.address1}, ` : '',
            debtorInfo.city ? `${debtorInfo.city}, ` : '',
            debtorInfo.state),
        displaySuper &&
            debtorInfo.IsSuperDebtor !== undefined &&
            debtorInfo.IsSuperDebtor !== 0 && (React.createElement("div", { className: "debtorSuperContent" }, "Super Debtor"))));
}
function renderHistoryIcon(history) {
    return !history || history === false ? (React.createElement("div", null)) : (React.createElement(RightElement, null,
        React.createElement("img", { src: history_svg_1.default })));
}
//# sourceMappingURL=DebtorMenuItem.js.map